module.exports = __webpack_public_path__ + "img/banner.2de02a31.png";